import React from "react";
import { SuccessIcon } from "./Icons";
import { ErrorIcon } from "./Icons";
import { FieldProps } from "../../types";
import { validators } from "../../languages";
import InputControl from "./InputControl";

export function FirstNameField(props: FieldProps) {
  const { formMethods, fieldClasses, inputWrapperClasses, inputClasses, disabled } = props;
  return (
    <InputControl
      fieldId="firstName"
      fieldName="firstName"
      fieldTitlePhraseKey="payment_step.field_labels.first_name"
      fieldType="text"
      fieldClasses={fieldClasses}
      inputWrapperClasses={inputWrapperClasses}
      inputClasses={inputClasses}
      labelClasses={"is-required"}
      formMethods={formMethods}
      attributes={{
        disabled: disabled,
        autoCorrect: "off",
        autoComplete: "given-name",
        "data-lpignore": "true"
      }}
      errorIcon={<ErrorIcon />}
      successIcon={<SuccessIcon />}
      validators={[validators.required, validators.invalidChars, validators.maxLength(32)]}
    />
  );
}

export default FirstNameField;
